<script setup lang="ts">
import ConfirmDialogHost from "@/components/ConfirmDialogHost.vue";
import IncognitoOverlay from "@/components/IncognitoOverlay.vue";
import PasswordPrompt from "@/components/PasswordPrompt.vue";
import { useRouter, RouterView } from "vue-router";

usePublicAccess();
useOrvalAxiosInterceptors();
useAxiosInterceptors();
useFlashMessages();
useRefetchUsers();

const router = useRouter();

onMounted(async (): Promise<void> => {
  await router.isReady();
  if (!router.currentRoute.value.name) {
    await router.replace({ name: "home" });
  }
});
const route = useRoute();
const { locale } = useI18n();

watch(
  () => route.query,
  (): void => {
    if (route.query.locale) {
      locale.value = route.query.locale as string;
    }
  }
);
</script>

<template>
  <IncognitoOverlay />
  <ConfirmDialogHost />
  <PasswordPrompt>
    <RouterView />
  </PasswordPrompt>
</template>
